import React from 'react';
import 'chart.js/auto';
import { Line, } from 'react-chartjs-2'

//import classes from './Card.module.css';

const LineChart = (props) => {

    //ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement);

    return (
        <div>
            <Line key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
                />
            </div>
    );
};

export default LineChart;
